// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Wq_YkL2CswPSovkhPVLPs"};